import { Atributo } from "./../../components/solicitacao/pesquisa-avancada-solicitacao/pesquisa-avancada-solicitacao.component";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSort } from "@angular/material";
import { MatPaginator } from "@angular/material";
import { MatTableDataSource } from "@angular/material";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
import { RelatorioModel } from "app/model/relatorio/relatorioModel";
import { ClienteService } from "app/service/cliente/cliente.service";
import { PermissoesService } from "app/service/usuario/permissoes.service";
import { RelatorioService } from "app/service/cliente/relatorio.service";

export interface Selects {
  id: String;
  atributo: String;
  descricao: String;
  tipoDado: String;
  alias: String;
}

@Component({
  selector: "app-criar-relatorio",
  templateUrl: "./criar-relatorio.component.html",
  styleUrls: ["./criar-relatorio.component.scss"],
})
export class CriarRelatorioComponent implements OnInit {
  @ViewChild("categoryPaginator", { read: MatPaginator })
  paginator: MatPaginator;
  @ViewChild("usersPaginator") usersPaginator: MatPaginator;
  // @ViewChild(MatPaginator) paginatorRelatorio: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort) sortRelatorio: MatSort;
  loading: boolean = true;
  // SNACKBAR
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  // FORM GROUPS
  public formRelatorio: FormGroup;
  public formQueryAtributos: FormGroup;

  relatorio = {} as RelatorioModel;
  relatorios: RelatorioModel[];

  // ARRAY ALIAS
  public indexLastAttributSelected: number = null;
  isEditAttribute: boolean = false;
  isEditSelect: boolean = false;
  public indexLastSelects: number = null;
  public indexLastOrdinations: number = null;
  selects: any[] = [];
  attributesAndOrdinations: any[] = [];
  isOrdination: boolean = false;

  typesReport: any[] = ["Relatório", "Fluxo de Trabalho"];
  // TABLES
  displayedColumns = ["name", "description", "ative"];
  displayedColumnsUser = ["nome", "acoes"];
  dataSource = new MatTableDataSource<any[]>([]);
  dataSourceRelatorio = new MatTableDataSource<RelatorioModel>([]);

  usuariosAuth: any[] = [];
  atributosANDdescricao: any[] = [];
  usuarios: any[] = [];
  usuariosBD: any[] = [];
  public mensagemErro: string;
  public clienteId: any;
  paginatorLength = 0;
  // PERMISSÕES
  arrayString: string;
  creatorRel: boolean = false;
  editorRel: boolean = false;
  listaRel: boolean = false;
  deletaRel: boolean = false;
  superUser: boolean = false;
  // NGIF'S
  isFluxoTrabalho: boolean = true;
  dataEdit;
  public submit: boolean = false;
  relSelected: number = null;
  assuntos;
  atributosByAssunto: any[] = [];
  lastAttribut: any = "";
  lastSelect: any = "";

  constructor(
    private fb: FormBuilder,
    public clientService: ClienteService,
    private route: ActivatedRoute,
    private permissionService: PermissoesService,
    private _snackBar: MatSnackBar,
    public relatorioService: RelatorioService,
    private dialogoRef: MatDialogRef<CriarRelatorioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log("DATA ETID: " + data.dataEdit);
    this.dataEdit = data.dataEdit;
    this.clienteId = data.idCliente;
    this.getPermissionCliente(this.clienteId);
  }

  ngOnInit() {
    this.getAssuntosRelatorio();
    this.formRelatorio = this.fb.group({
      name: [null, [Validators.required, Validators.maxLength(80)]],
      description: [null, [Validators.required, Validators.maxLength(80)]],
      ative: [true],
      showProperties: [true],
      searchLanguage: ["afts", [Validators.required]],
      searchText: [null, [Validators.required, Validators.maxLength(255)]],
      cliente: [null],
      authUsers: [null],
      reportType: [" ", Validators.required],
      aliasRelatorio: [""],
      selectsRelatorio: [""],
      agrupamento: [""],
      assuntoRelatorioId: [""],
    });

    this.formQueryAtributos = this.fb.group({
      idAtributos: [""],
      atributoAtributos: ["", Validators.required],
      descricaoAtributos: [""],
      nomeTabelaAtributo: [""],
      tipoDadoAtributos: [""],
      aliasAtributo: [""],
      ordemAtributos: ["null"],
      idSelects: [""],
      atributoSelects: ["", Validators.required],
      descricaoSelects: [""],
      nomeTabelaSelect: [""],
      aliasSelect: [""],
      assuntoId: [""],

      isOrdination: [{ value: false, disabled: true }],
      isGrouping: [{ value: false, disabled: true }],
    });
    this.clientService.getClienteUnico(this.clienteId).subscribe(
      (data) => {
        this.formRelatorio.get("cliente").setValue(data);
      },
      (err) => {
        this.openSnackBarError(
          "Erro ao buscar Empresa, tente novamente mais tarde"
        );
      }
    );

    // this.getRelatoriosByIdCliente(this.clienteId);
    if (this.dataEdit != undefined && this.dataEdit != null) {
      this.getDadosRelatorioEdit(this.dataEdit);
    }

    this.getUsuarios();
  }

  getAssuntosRelatorio() {
    this.relatorioService.getAssuntosRelatorio().subscribe({
      next: (data) => {
        // console.log(data);
        this.assuntos = data;

        if (this.relatorio.id != null) {
          this.assuntos.forEach((element) => {
            if (element.id == this.dataEdit.assuntoRelatorioId) {
              this.formQueryAtributos.get("assuntoId").setValue(element.id);
              this.executeQueryAssunto(element.nomeTabela);
            }
          });
        }
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  changeAssunto(assuntoId) {
    this.selects = [];
    this.atributosANDdescricao = [];
    this.executeQueryAssunto(assuntoId);
  }
  executeQueryAssunto(idAssunto: number) {
    this.relatorioService.executeQueryAssunto(idAssunto).subscribe({
      next: (data) => {
        console.log(data);
        this.atributosByAssunto = data;
      },
      error: (err) => {
        console.error(err);
      },
    });
  }
  changeAtributoGetAlias(e, which) {
    console.log(e);
    if (which === "SELECT") {
      this.atributosByAssunto.forEach((el) => {
        if (el.atributo === e) {
          console.log("atributosIguais");
          this.formQueryAtributos.get("aliasSelect").setValue(el.aliasTabela);
          this.formQueryAtributos
            .get("nomeTabelaSelect")
            .setValue(el.nomeTabela);
        }
      });
      // ATRIBUTO
    } else {
      console.log(this.atributosByAssunto);
      this.atributosByAssunto.forEach((el) => {
        if (el.atributo === e) {
          console.log("atributosIguais");
          this.formQueryAtributos.get("aliasAtributo").setValue(el.aliasTabela);
          this.formQueryAtributos
            .get("tipoDadoAtributos")
            .setValue(el.tipoDado);
          this.formQueryAtributos
            .get("nomeTabelaAtributo")
            .setValue(el.nomeTabela);
        }
      });
    }

    console.log(this.formQueryAtributos.value);
  }
  changeOrdination(e) {
    if (e.checked) {
      this.isOrdination = true;
    } else {
      this.isOrdination = false;
    }
  }

  // changeDataType(ev) {
  //   console.log(ev);
  //   this.formQueryAtributos.get("tipoDadoAtributos").setValue("");
  //   this.formQueryAtributos.get("tipoDadoAtributos").setValue(ev);
  // }
  // changeAgrupamento(e) {
  //   if (e.checked) {
  //     this.formQueryAtributos.get("isGrouping").setValue(true);
  //   } else {
  //     this.formQueryAtributos.get("isGrouping").setValue(false);
  //   }
  // }

  // ARRAY ALIAS

  addAlias(whichAdd) {
    console.log(whichAdd);
    if (whichAdd === "ATRIBUTOS") {
      let att = this.formQueryAtributos.get("atributoAtributos").value;
      let desc = this.formQueryAtributos.get("descricaoAtributos").value;
      let dataType = this.formQueryAtributos.get("tipoDadoAtributos").value;
      let order = this.formQueryAtributos.get("ordemAtributos").value;
      let alias = this.formQueryAtributos.get("aliasAtributo").value;
      let nomeTabelaAtributo =
        this.formQueryAtributos.get("nomeTabelaAtributo").value;
      let inserir = true;

      if (
        att.length > 0 &&
        desc.length > 0
        // dataType.length > 0 &&
        // order == ""
      ) {
        if (order == "null") {
          order = null;
        }
        console.log(this.atributosANDdescricao);
        console.log(this.atributosByAssunto);
        this.atributosANDdescricao.forEach((el) => {
          if (el.atributo === att && el.nomeTabela === nomeTabelaAtributo) {
            inserir = false;
          }
        });
        console.log(inserir);
        if (inserir) {
          this.atributosANDdescricao.push({
            id: null,
            atributo: att,
            descricao: desc,
            tipoDado: dataType,
            ordem: order,
            alias: alias,
            nomeTabela: nomeTabelaAtributo,
          });
          // console.log(this.atributosANDdescricao);
          this.formQueryAtributos.get("isOrdination").enable();
          this.formQueryAtributos.get("atributoAtributos").setValue("");
          this.formQueryAtributos.get("descricaoAtributos").setValue("");
          this.formQueryAtributos.get("ordemAtributos").setValue("null");
          // this.formQueryAtributos.get("tipoDadoAtributos").setValue("");
        } else {
          this.openSnackBarError(
            "Filtro de busca já está em uso, escolha outro."
          );
        }
      } else {
        this.openSnackBarError("Adicione um valor para o texto de pesquisa");
      }
    } else {
      // WICHADD É SELECT
      let att = this.formQueryAtributos.get("atributoSelects").value;
      let desc = this.formQueryAtributos.get("descricaoSelects").value;
      let alias = this.formQueryAtributos.get("aliasSelect").value;
      let nomeTabelaSelect =
        this.formQueryAtributos.get("nomeTabelaSelect").value;
      let inserir = true;
      if (att.length > 0 && desc.length > 0) {
        this.selects.forEach((el) => {
          if (el.atributo === att && el.nomeTabela == nomeTabelaSelect) {
            inserir = false;
          }
        });

        if (inserir) {
          this.selects.push({
            id: null,
            atributo: att,
            descricao: desc,
            alias: alias,
            nomeTabela: nomeTabelaSelect,
          });
          this.formQueryAtributos.get("isGrouping").enable();
          // console.log(this.selects);
          this.formQueryAtributos.get("atributoSelects").setValue("");
          this.formQueryAtributos.get("descricaoSelects").setValue("");
        } else {
          this.openSnackBarError(
            "Campos de Apresentação já está em uso, escolha outro."
          );
        }
      } else {
        this.openSnackBarError("Adicione um valor para o texto de pesquisa");
      }
    }
  }

  addOrdination() {
    let attribute = this.formQueryAtributos.get("atributoOrdenacao").value;
    let order = this.formQueryAtributos.get("ordem").value;

    if (attribute.length > 0 && order.length > 0) {
      let attAndOrd = {
        atributo: attribute,
        ordem: order,
      };
      this.attributesAndOrdinations.push(attAndOrd);

      this.formQueryAtributos.get("atributoOrdenacao").setValue("");
      this.formQueryAtributos.get("ordem").setValue("");
    } else {
      this.openSnackBarError("Adicione valores para ordenação");
    }
  }

  deleteAttribute(i) {
    let index = this.atributosANDdescricao.indexOf(i);
    if (index > -1) {
      this.atributosANDdescricao.splice(index, 1);
    }
  }
  deleteSelect(item) {
    let index = this.selects.indexOf(item);
    if (index > -1) {
      this.selects.splice(index, 1);
    }
  }

  edits(item, whichEdit) {
    // console.log(item);
    switch (whichEdit) {
      case "SELECTS":
        this.indexLastSelects = null;
        this.formQueryAtributos.get("atributoSelects").setValue(item.atributo);
        this.formQueryAtributos
          .get("descricaoSelects")
          .setValue(item.descricao);
        this.formQueryAtributos.get("idSelects").setValue(item.id);
        this.indexLastSelects = this.selects.indexOf(item);
        this.lastSelect = this.selects[this.indexLastSelects];
        this.isEditSelect = true;
        break;
      case "ATRIBUTOSDESC":
        this.indexLastAttributSelected = null;
        this.formQueryAtributos
          .get("atributoAtributos")
          .setValue(item.atributo);
        this.formQueryAtributos
          .get("descricaoAtributos")
          .setValue(item.descricao);
        // this.formQueryAtributos
        //   .get("tipoDadoAtributos")
        //   .setValue(item.tipoDado);
        this.formQueryAtributos.get("ordemAtributos").setValue(item.ordem);
        this.formQueryAtributos.get("idAtributos").setValue(item.id);
        this.indexLastAttributSelected =
          this.atributosANDdescricao.indexOf(item);
        this.lastAttribut =
          this.atributosANDdescricao[this.indexLastAttributSelected];
        this.isEditAttribute = true;
        break;
    }
  }

  confirms(whichConfirmEdit) {
    console.log(whichConfirmEdit);
    switch (whichConfirmEdit) {
      case "SELECTS":
        let att = this.formQueryAtributos.get("atributoSelects").value;
        let desc = this.formQueryAtributos.get("descricaoSelects").value;
        let id = this.formQueryAtributos.get("idSelects").value;
        let nomeTabelaSelect =
          this.formQueryAtributos.get("nomeTabelaSelect").value;
        let newAttribute = {
          id: id,
          atributo: att,
          descricao: desc,
          tipoDado: "",
          alias: "",
          ordem: "",
          nomeTabela: nomeTabelaSelect,
        };

        if (desc.length <= 0 || att.length <= 0) {
          this.openSnackBarError("Adicione valor para salvar a edição.");
        } else {
          let inserirSelect: boolean = true;
          this.selects.forEach((el) => {
            if (
              el.nomeTabela === nomeTabelaSelect &&
              el.nomeTabela !== this.lastSelect.nomeTabela &&
              el.atributo !== this.lastSelect.atributo
            ) {
              inserirSelect = false;
            }
          });

          if (inserirSelect) {
            this.selects[this.indexLastSelects] = newAttribute;
            this.formQueryAtributos.get("atributoSelects").setValue("");
            this.formQueryAtributos.get("descricaoSelects").setValue("");
            this.isEditSelect = false;
          } else {
            this.openSnackBarError(
              "Campos de Apresentação já está em uso, escolha outro."
            );
          }
        }

        break;
      case "ATRIBUTOSDESC":
        let attByAttribute =
          this.formQueryAtributos.get("atributoAtributos").value;
        let descByAttribute =
          this.formQueryAtributos.get("descricaoAtributos").value;
        let dataTypeByAttribute =
          this.formQueryAtributos.get("tipoDadoAtributos").value;
        let idByAttribute = this.formQueryAtributos.get("idAtributos").value;
        let order = this.formQueryAtributos.get("ordemAtributos").value;
        let alias = this.formQueryAtributos.get("aliasAtributo").value;
        let nomeTabelaAtributo =
          this.formQueryAtributos.get("nomeTabelaAtributo").value;
        let newAttributeByAttribute = {
          id: idByAttribute,
          atributo: attByAttribute,
          descricao: descByAttribute,
          tipoDado: dataTypeByAttribute,
          ordem: order,
          alias: alias,
          nomeTabela: nomeTabelaAtributo,
        };

        if (descByAttribute.length <= 0 || attByAttribute.length <= 0) {
          this.openSnackBarError("Adicione valor para salvar a edição.");
        } else {
          let inserirAtr = true;
          this.atributosANDdescricao.forEach((el) => {
            if (
              el.nomeTabela === nomeTabelaAtributo &&
              el.nomeTabela !== this.lastAttribut.nomeTabela &&
              el.Atributo !== this.lastAttribut.atributo
            ) {
              inserirAtr = false;
            }
          });
          if (inserirAtr) {
            this.atributosANDdescricao[this.indexLastAttributSelected] =
              newAttributeByAttribute;
            this.formQueryAtributos.get("atributoAtributos").setValue("");
            this.formQueryAtributos.get("descricaoAtributos").setValue("");
            // this.formQueryAtributos.get("tipoDadoAtributos").setValue(" ");
            this.formQueryAtributos.get("ordemAtributos").setValue("null");
            this.isEditAttribute = false;
          } else {
            this.openSnackBarError(
              "Filtro de busca já está em uso, escolha outro"
            );
          }
        }
        break;
    }
  }
  // CHANGE'S
  changeReportType(ev) {
    // console.log(ev);
    this.limparForm();
    if (ev === "FLUXO_TRABALHO") {
      this.isFluxoTrabalho = true;
      this.formRelatorio.get("searchText").setValue("");

      let input = document.getElementById("name-relatorio");
      input.classList.remove("form-control");
      input.classList.add("form-control-fluxo-trabalho");
    } else {
      this.relatorio.searchLanguage = "afts";
      this.relatorio.showProperties = true;
      this.isFluxoTrabalho = false;
      let input = document.getElementById("name-relatorio");
      input.classList.remove("form-control-fluxo-trabalho");
      input.classList.add("form-control");
    }
  }

  onLanguageChange(e) {
    this.relatorio.searchLanguage = e;
  }

  onSubmit() {
    this.submit = true;
  }

  postSubmit() {
    this.submit = false;
  }

  saveOrEditRelatorio() {
    if (this.relatorio.id !== undefined) {
      this.editRelatorio();
    } else {
      this.adicionarRelatorio();
    }
  }

  setRelSelected(id) {
    this.relSelected = id;
  }

  limparForm(): void {
    this.relatorio = new RelatorioModel();
    this.formRelatorio.get("name").setValue(null);
    this.formRelatorio.get("description").setValue(null);
    this.formRelatorio.get("ative").setValue(true);
    this.formRelatorio.get("showProperties").setValue(true);
    this.formRelatorio.get("searchLanguage").setValue("afts");
    this.formRelatorio.get("searchText").setValue(null);
    this.formRelatorio.get("authUsers").setValue(null);
    this.usuariosAuth.splice(0, this.usuariosAuth.length);
    this.atributosANDdescricao = [];
    this.selects = [];
    this.formQueryAtributos.get("ordemAtributos").setValue("null");
    // this.formQueryAtributos.get("tipoDadoAtributos").setValue(" ");
    this.formQueryAtributos.get("isGrouping").setValue(false);
    this.formQueryAtributos.get("isGrouping").disable();
  }

  getPermissionCliente(idCliente: number) {
    this.loading = true;
    this.permissionService.getPermissionEmpresa(idCliente).subscribe(
      (data) => {
        const arrayAuthorityCliente: any[] = [];
        data.forEach((el) => {
          arrayAuthorityCliente.push(el.authority);
        });
        this.permissionService.setItemAuthority(
          "authority-Empresa",
          arrayAuthorityCliente
        );
        this.getAuthority();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        console.error(err);
        this.openSnackBarError("Ocorreu um erro, tente novamente mais tarde");
      }
    );
  }

  getAuthority() {
    this.arrayString =
      this.permissionService.getItemAuthority("authority-Empresa");
    if (this.arrayString.includes("SUPER_USER")) {
      this.superUser = true;
    }
    if (this.arrayString.includes("LIST_RELATORIO")) {
      this.listaRel = true;
    }
    if (this.arrayString.includes("ADD_RELATORIO")) {
      this.creatorRel = true;
    }
    if (this.arrayString.includes("EDIT_RELATORIO")) {
      this.editorRel = true;
    }
    if (this.arrayString.includes("DELETE_RELATORIO")) {
      this.deletaRel = true;
    }
    if (this.superUser || this.deletaRel || this.editorRel) {
      this.displayedColumns.push("acoes");
    }
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  aplicarFiltrosRel(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSourceRelatorio.filter = filter;
  }

  setFields() {
    this.formRelatorio.get("ative").setValue(true);
    this.formRelatorio.get("showProperties").setValue(true);
  }

  clearArrayUsuarios() {
    this.usuariosAuth.splice(0, this.usuariosAuth.length);
  }

  setUserAuthorized(id: number) {
    const foundAuthorized = this.usuariosAuth.find((x) => x.id === id);
    const found = this.usuarios.find((x) => x.id === id);
    if (foundAuthorized != null) {
      console.error("error");
      this.openSnackBarError(`Usuário ${foundAuthorized.nome} já adicionado !`);
    } else {
      this.usuariosAuth.push(found);
    }
  }

  removeUserAuthorized(id: number) {
    const foundIndex = this.usuariosAuth.findIndex((x) => x.id === id);
    const foundAuthorized = this.usuariosAuth.find((x) => x.id === id);
    const found = this.usuarios.find((x) => x.id === id);
    if (foundIndex > -1) {
      this.usuariosAuth.splice(foundIndex, 1);
    }
    if (found != null) {
      console.error("error");
    } else {
      this.usuarios.push(foundAuthorized);
    }
  }

  getUsuarios() {
    this.relatorioService.getUsuariosPorCliente(this.clienteId).subscribe(
      (data) => {
        this.usuarios = data.map((element) => ({
          id: element.id,
          nome: element.nome,
        }));

        this.dataSource.data = this.usuarios;
        this.dataSource.paginator = this.usersPaginator;
        this.paginatorLength = this.usuarios.length;
        this.dataSource.sort = this.sort;
      },
      (err) => {
        console.error(err);
        this.openSnackBarError(
          "Erro ao buscar Usuários, tente novamente mais tarde"
        );
      }
    );
  }

  adicionarRelatorio() {
    // console.log(this.isFluxoTrabalho);

    if (this.isFluxoTrabalho === true) {
      this.formRelatorio.get("searchLanguage").setValue("sql");
      this.formRelatorio.get("showProperties").setValue(false);
    }

    this.formRelatorio
      .get("assuntoRelatorioId")
      .setValue(this.formQueryAtributos.get("assuntoId").value);
    console.log(this.usuariosAuth);
    this.formRelatorio.get("authUsers").setValue(this.usuariosAuth);
    // console.log(this.atributosANDdescricao);
    this.formRelatorio
      .get("aliasRelatorio")
      .setValue(this.atributosANDdescricao);

    this.formRelatorio.get("selectsRelatorio").setValue(this.selects);

    // this.formRelatorio
    //   .get("agrupamento")
    //   .setValue(this.formQueryAtributos.get("isGrouping").value);

    // console.log(this.formRelatorio.value);
    if (
      (this.isFluxoTrabalho === true && this.selects.length == 0) ||
      (this.isFluxoTrabalho === true && this.atributosANDdescricao.length == 0)
    ) {
      this.openSnackBarError("Preencha todos os campos");
    } else {
      console.log(this.formRelatorio.value);
      this.relatorioService
        .postRelatorio(this.formRelatorio.value, this.clienteId)
        .subscribe(
          (r) => {
            // console.log(r)
            this.limparForm();
            // this.relatorio = new RelatorioModel();
            // this.getRelatoriosByIdCliente(this.clienteId);
            // this.usuariosAuth.splice(0, this.usuariosAuth.length);
            this.dialogoRef.close(r);
            this.getUsuarios();
            this.openSnackBarSuccess("Relatório salvo com sucesso !");
            this.postSubmit();
          },
          (error) => {
            console.error(error);
            if (error.status === 400) {
              this.mensagemErro = "Preencha todos os campos obrigatórios!";
              this.openSnackBarError("Erro ao tentar salvar o Relatório !");
            } else {
              this.mensagemErro = error.error.message;
              if (this.mensagemErro === "Relatório já criado com este código") {
                this.openSnackBarError(this.mensagemErro);
              } else {
                this.openSnackBarError(`Erro ao tentar salvar o Relatório !`);
              }
            }
          }
        );
    }
  }
  editRelatorio() {
    console.log(this.relatorio);
    // console.log(this.formRelatorio.value);
    if ((this.isFluxoTrabalho) && (this.selects.length <= 0 || this.atributosANDdescricao.length <= 0)) {
      this.openSnackBarError("Preencha todos os campos");
    } else {
      this.relatorio.authUsers = this.usuariosAuth;
      this.relatorioService
        .putRelatorio(this.relatorio, this.clienteId)
        .subscribe(
          (data) => {
            // this.getRelatoriosByIdCliente(this.clienteId);
            this.openSnackBarSuccess("Relatório atualizado com sucesso !");
            this.dialogoRef.close(data);
          },
          (err) => {
            this.mensagemErro = err.error.message;
            console.error(err);
            this.openSnackBarError(`Erro ao atualizar o Relatório !`);
          }
        );
    }
  }

  deletarRelatorio() {
    this.relatorioService.deletarRelatorio(this.relSelected).subscribe(
      () => {
        // this.getRelatoriosByIdCliente(this.clienteId);
        this.openSnackBarSuccess("Relatório excluído com sucesso !");
      },
      (err) => {
        this.openSnackBarError("Erro ao tentar excluir o Relatório !");
        console.error(err);
      }
    );
  }

  getDadosRelatorioEdit(relatorio: RelatorioModel) {
    console.log(relatorio);
    if (relatorio.selectsRelatorio.length != 0) {
      this.formQueryAtributos.get("isGrouping").enable();
    }
    // console.log(relatorio.aliasRelatorio);
    if (relatorio.reportType === null) {
      this.formRelatorio.get("reportType").setValue("REPOSITORIO");
    } else {
      this.formRelatorio.get("reportType").setValue(relatorio.reportType);
    }

    if (relatorio.reportType === "FLUXO_TRABALHO") {
      this.isFluxoTrabalho = true;
    } else {
      this.isFluxoTrabalho = false;
    }

    // console.log(relatorio.aliasRelatorio);
    this.executeQueryAssunto(relatorio.assuntoRelatorioId);
    this.atributosANDdescricao = [];
    this.atributosANDdescricao = relatorio.aliasRelatorio;
    this.selects = relatorio.selectsRelatorio;
    if (this.selects.length > 0) {
      this.formQueryAtributos.get("atributoSelects").clearValidators();
    }

    if (this.atributosANDdescricao.length > 0) {
      this.formQueryAtributos.get("atributoAtributos").clearValidators();
    }
    this.relatorio = { ...relatorio };
    this.getUsuariosRelatorioBD(relatorio.id);

    // console.log(this.relatorio);
  }

  getUsuariosRelatorioBD(idRelatorio: number) {
    this.relatorioService.getUsersByRelatorioId(idRelatorio).subscribe(
      (data) => {
        this.usuariosBD = data;
        this.getUsuarios();
        this.usuariosAuth = this.usuariosBD;
      },
      (err) => {
        console.error(err);
        this.openSnackBarError(
          "Erro ao buscar usuários, tente novamente mais tarde"
        );
      }
    );
  }

  // SnackBar's
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/config-relatorio/criar-relatorio/criar-relatorio.component.ts